import React, {useRef, useState} from "react";
import {Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import PopUp from "../popUp/PopUp";
import FaultMgmt from "../../pages/subPages/FaultMgmt";
import TableTopBar from "./top/TableTopBar";
import AxcBadge from "../common/AxcBadge";
import Pagination from "../common/Pagination";
import {useDownloadExcel} from "react-export-table-to-excel";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {getFSListAll} from "../../api/apiClient";
import Swal from "sweetalert2";
import html2canvas from "html2canvas";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import usePdf from "../../hook/usePdf";

const TableFS = ({
                   currentPage,
                   setCurrentPage,
                   listPageSize,
                   setListPageSize,
                   total,
                   tableList,
                   getFullData = null,
                   setIsSearch,
                   searchParam,
                   setSearchParam,
                   updateList,
                   setTableList,
                   setTotal
                 }) => {

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setIsSearch(true);
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  // popup
  const [stPopup, setPopup] = useState(false);
  const [stPopupId, setPopupId] = useState({
    lc: '',
    cause_id: '',
  });

  const openPopup = (lc, id) => {
    setPopupId({
      lc: lc,
      cause_id: id
    });
    setPopup(true);
  };

  const closePopup = () => {
    setPopup(false);
    setIsSearch(true);
    updateList();
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "장애현황_.xls")
  }

  const getAllList = () => {
    setIsExport(true);
    getFSListAll(
        searchParam.searchFcltyNo,
        searchParam.searchLcKnd,
        searchParam.searchMssage)
        .then((res) => {
              // console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);
      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        exportPdf(tableRef, '장애현황.pdf');
      }
      setIsExport(false);
      updateList();
    });
  };

  return (
      <>
        <PopUp
            propTitle={'장애 관리'}
            propShow={stPopup}
            propSize={'lg'}
            setShow={closePopup}
        >
          <FaultMgmt
              propCauseId={stPopupId.cause_id}
              propLc={stPopupId.lc}
              hClose={closePopup}
          />
        </PopUp>
        <Row>
          <Col md={6} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: getFullData,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '장애현황',
                  }),
                }}
                propDelete={{
                  isEnable: false,
                  // delFunc: delItem,
                }}
                propReg={{
                  isEnable: false,
                  // regFunc: regItem,
                }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center"} ref={tableRef} id={'table'}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  <th className={"col"}>등급</th>
                  <th className={"col"}>발생시간</th>
                  <th className={"col"}>장애원인</th>
                  <th className={"col"}>상태</th>
                  <th className={"col"}>발생유형</th>
                  <th className={"col"}>자치구</th>
                  <th className={"col"}>발생위치</th>
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        return (
                            <tr key={idx}>
                              <td>
                                <AxcBadge
                                    propInput={elem.serius_level_nm}
                                    propDangerText={'Critical'}
                                    propWarningText={'Major'}
                                    propMinorWarningText={'Minor'}
                                />
                              </td>
                              <td>{elem.ocrn_dt_str}</td>
                              <td>{elem.cause_nm}
                              </td>
                              <td>{elem.sttus_nm}</td>
                              <td>{elem.lc_knd_nm}</td>
                              <td>{elem.atdrc_nm}</td>
                              <td>{elem.mssage}</td>
                            </tr>
                        );
                      })) : ('')
                }
                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={""}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
                propSetIsSearch={setIsSearch}
                propSearchParam={searchParam}
                propSetSearchParam={setSearchParam}
            />
          </Col>
        </Row>
      </>
  );
};


export default TableFS;
